export default __webpack_public_path__ + "35b4fba2e2b610210d4daf4c905e3e19.woff";